export default {
  appId: '312891810048855',
};
